import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OrdersService {
  constructor(private http: HttpClient) {}

  // Get All Orders
  public getAllOrders(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-purchase' + paginationString + sortString, {
        observe: 'response',
      })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getAllORdersByStore(storeid, pagination, sort, filters) {
    let filterString = 'id=563';
    let searchString = '';
    const sortString = '&sort=' + sort;

    // tslint:disable-next-line:forin
    for (const prop in filters) {
      if (prop !== 'submit' && filters[prop] !== '' && filters[prop] !== null) {
        filterString += '&' + prop + '=' + filters[prop];
      }
    }

    if (filterString !== '') {
      searchString = '/search/';
    }

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    // return this.http.get(environment.apiUrl + 'api/ext-item/by-store/' + storeid + searchString + paginationString + filterString + sortString, { observe: 'response' })
    return this.http
      .get(environment.apiUrl + 'api/ext-purchase/by-store/' + storeid + paginationString + sortString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getPurchasesForStoreBetweenDates(storeid, start, end) {
    let paginationString = '';
    paginationString += '?size=99999';
    paginationString += '&page=0';

    let dateString = '';
    dateString += '&startDate=' + start;
    dateString += '&endDate=' + end;

    return this.http
      .get(environment.apiUrl + 'api/ext-purchase/between-dates/by-store/' + storeid + paginationString + dateString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getOrderById(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-purchase/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getChargeByOrderId(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-charge/by-purchase/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public refundOrderStripe(obj) {
    return this.http
      .post(environment.apiUrl + 'api/ext-refund', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/orders.service.ts